class CartDrawerFeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('slider-component');
    this.productGrid = this.querySelector('.product-grid');
    this.productsToDisplay = 8;
    this.init();
  }

  init() {
    // Get a list of all current products in the cart to exclude them from recommendations
    const cartItems = document.querySelectorAll('.cart-item');
    const cartProductIds = Array.from(cartItems).map(item => {
      const link = item.querySelector('.cart-item__name');
      return link ? this.getProductIdFromURL(link.href) : null;
    }).filter(id => id !== null);

    // Fetch random products from the catalog
    this.getRandomProducts(cartProductIds);
  }

  getProductIdFromURL(url) {
    const match = url.match(/\/products\/([a-zA-Z0-9-_]+)/);
    return match ? match[1] : null;
  }

  getRandomProducts(excludeIds) {
    // Fetch from recommended products endpoint or all products collection
    fetch('/recommendations/products.json?product_id=' + (excludeIds[0] || 'random') + '&limit=24')
      .then(response => response.json())
      .then(data => {
        if (!data.products) {
          console.error('No products found in response:', data);
          this.classList.add('is-empty');
          return;
        }

        // Filter out any products that are in the cart
        let products = data.products.filter(product => {
          const handle = this.getProductIdFromURL(product.url);
          return handle && !excludeIds.includes(handle) && product.available;
        });

        // Shuffle the products to get a random selection
        products = this.shuffleArray(products);

        // Limit to the number we want to display
        products = products.slice(0, this.productsToDisplay);

        if (products.length > 0) {
          this.renderProducts(products);
        } else {
          this.classList.add('is-empty');
        }
      })
      .catch(error => {
        console.error('Error fetching random products:', error);
        this.classList.add('is-empty');
      });
  }

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  renderProducts(products) {
    // Only render if we have the product grid
    if (!this.productGrid) return;

    // Clear any existing slides
    this.productGrid.innerHTML = '';

    // Create a slide for each product
    products.forEach((product, index) => {
      const slide = document.createElement('li');
      slide.id = `CartDrawer-FeaturedSlide-${index + 1}`;
      slide.classList.add('grid__item', 'slider__slide');

      // Basic product card HTML
      slide.innerHTML = `
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media">
            <div class="card__inner">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img
                    src="${product.featured_image}"
                    alt="${product.title}"
                    loading="lazy"
                    width="533"
                    height="533"
                  >
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="${product.url}" class="full-unstyled-link">
                      ${product.title}
                    </a>
                  </h3>
                  <div class="card-information">
                    <div class="price">
                      <span class="price-item price-item--regular">
                        ${this.formatMoney(product.price)}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="quick-add">
                  <a href="${product.url}" class="button button--full-width">
                    View Product
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      this.productGrid.appendChild(slide);
    });

    // Update counter total
    const counterTotal = this.querySelector('.slider-counter--total');
    if (counterTotal) {
      counterTotal.textContent = products.length;
    }

    // Initialize slider functionality if needed
    if (this.slider) {
      this.slider.init();
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents || 0, 10);
    const dollars = Math.floor(value / 100);
    const cents_part = (value % 100).toString().padStart(2, '0');
    
    return `$${dollars}.${cents_part}`;
  }
}

if (!customElements.get('cart-drawer-featured-products')) {
  customElements.define('cart-drawer-featured-products', CartDrawerFeaturedProducts);
} 